<div (click)="collapse()" class="cloud-sub-group cl-collapse-title">{{title}}
  <i *ngIf="!collapsed" class="fas fa-caret-up"></i>
  <i *ngIf="collapsed" class="fas fa-caret-down"></i>
</div>
<div style="width: 100%;"   [ngClass]="{'fadeIn': !collapsable, 'slideOutLeft': collapsable}"
  *ngIf="!collapsed">
  <ng-content></ng-content>
</div>